<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>Copyright &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://www.rekomgroup.com" target="_blank" rel="nofollow">Rekom</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        }
    }
}
</script>
